import { useCallback, useMemo } from 'react';
import { type OpenApiSchemaCategory } from '#shared/api/schema';
import { enrichCategoriesWithParentPath } from '#shared/lib/category';
import { useCategoryGetAll } from '../api';

export const useFilterTitleByValue: (values: string[]) => { value: string; title: string }[] = (values) => {
    const { data: categories } = useCategoryGetAll({});

    const categoriesWithPaths = useMemo(() => enrichCategoriesWithParentPath(categories ?? []), [categories]);

    const getCategoryTitle = useCallback(
        (categoryId: OpenApiSchemaCategory['id']): string =>
            categoriesWithPaths.find((category) => category.id === categoryId)?.parentsPath ?? categoryId,
        [categoriesWithPaths]
    );

    return useMemo(
        () =>
            values.map((value) => {
                return { value, title: getCategoryTitle(value) };
            }),
        [getCategoryTitle, values]
    );
};
